import React from "react";
import {Helmet} from "react-helmet";

export default function Stitches() {
    return (
        <div>
            <Helmet>
                <title>缝针 Stitches</title>
            </Helmet>
            <h6 className="App-essay-title">缝针</h6>
            <p className="App-essay-article">
                <br/>
                <b>二〇二五 三月</b>
                <br/><br/>
                几个月前和爸妈去秦岭里玩儿。他们开车，我坐在后排半躺着。“秦国”的路他们比我熟得多。
                <br/><br/>
                我妈突然问我爸：你当时胆子太大了，那么大的伤口都敢处理？
                <br/><br/>
                我妈说的是多年前，我爸接诊过一个外伤病人。一个年轻小伙子，打架被砍了很多刀，胸口和肩膀的大口子如同刚从解剖室出来，像一头被剖开的猪。
                <br/><br/>
                我爸没说话，径直开始手术，缝了上百针。小伙子是跑江湖的，青龙纹身，但身无分文。我爸没开医药单就让他走了。
                <br/><br/>
                我妈问他：你当时怎么想的？怎么敢接这样的伤口？
                <br/><br/>
                我爸说：我当时也年轻。他也没钱，我不救他，他就死在马路牙上。
                <br/><br/>
                我妈说：那小伙子被缝好，歇了一会儿就站起来，把白背心像毛巾一样，拧了一地血水，穿上背心就走了。年轻人恢复得很快。我跑上楼就吐了。
                <br/><br/>
                我说：伤口这么夸张？<br/>
                我妈说：嗯，还因为你在我肚子里。
                <br/><br/>
                谢了爸妈，你们总有一些故事，比我的故事传奇得多。有些记忆不注意就会溜进脑海里。
                <br/><br/><br/>
                <i style={{color: "darkgray"}}>Written on the coast of the East Pacific Ocean.</i>
                <br/>
                <i style={{color: "darkgray"}}>写于东太平洋沿岸。</i>
            </p>

            <br/>

            <h6 className="App-essay-title">Stitches</h6>
            <p className="App-essay-article">
                <br/>
                <b>Mar 2025</b>
                <br/><br/>
                A few months ago, I went to the Qin Mountains with my parents. They were driving while I lay half-reclined in the backseat. They knew these "Qin Empire" roads much better than I did.
                <br/><br/>
                Out of blue, my mother asked my father, "Why did you handle such massive wounds back then?"
                <br/><br/>
                She was referring to an incident years ago when my father treated a trauma patient. A young man who'd been slashed multiple times in a fight - the gaping wounds on his chest and shoulders looked like he'd just walked out of a dissection room, like a slaughtered pig.
                <br/><br/>
                My father hadn't spoken, just immediately began surgery, stitching over a hundred sutures. The young man was a gangster with a blue dragon tattoo, penniless. My father let him leave without even writing a medical bill.
                <br/><br/>
                My mother pressed, "What were you thinking? How could you treat such injuries?"
                <br/><br/>
                "I was young then too," my father replied. "He had no money. If I didn't save him, he'd have died on the curb."
                <br/><br/>
                My mother continued, "After being stitched up, that young man rested briefly, then stood up. He wrung out his white tank top like a towel - blood water splattered everywhere. Then he put the shirt back on and left. Young people heal fast. I ran upstairs and vomited."
                <br/><br/>
                I asked, "wounds that horrific?" My mother nodded. "Yes. And also because you were in my belly at the time."
                <br/><br/>
                Thanks, Mom and Dad. You always have legendary stories. Memories slip quietly into your mind when you least expect it.
                <br/><br/>
                <i style={{color: "darkgray"}}>Written on the coast of the East Pacific Ocean.</i>

            </p>
        </div>)
}
